/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateBlueprintRequest {
    getFixupPrototypeFunction() { return CreateBlueprintRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateBlueprintRequest>): CreateBlueprintRequest {
        let obj = Object.assign(new CreateBlueprintRequest(), model);
        CreateBlueprintRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateBlueprintRequest>): CreateBlueprintRequest {
        if (!model) return null;
        return CreateBlueprintRequest.newInstance(<CreateBlueprintRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateBlueprintRequest) {
        if (!obj) return;

        models.CreateBlueprintRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateBlueprintRequest): boolean {
        Object.setPrototypeOf(obj, CreateBlueprintRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resources) {
            for (let val of this.resources) {
                models.ResourceRequest.fixupPrototype(val);
            }
        }
    }

    /**
     * Blueprint Name
     */
    name: string;

    /**
     * Resource Details
     */
    resources: Array<models.ResourceRequest>;

    /**
     * Scope of the Blueprint
     */
    scope: models.BlueprintScope;

}
